import { useAudienceInterestEligible } from '@/services/AudienceInterest'
import { AudienceInterestPreviewCTA } from './AudienceInterestPreviewCTA'

export const AudienceInterestEligibilityWrapper = () => {
  const { data, loading, error } = useAudienceInterestEligible()

  if (loading || error) return null

  // hide if user is not eligible or if there are no films to preview
  if (!data?.user?.guildActions?.audienceInterestFilmEligible || !data?.userAudienceInterestFilmCount) return null

  return <AudienceInterestPreviewCTA />
}
